import { Reveal, Overline } from "./Reveal";
import { gallery } from "./data";

const Gallery = () => (
  <section
    data-testid="gallery-section"
    className="bg-white py-24 md:py-32 border-t border-slate-100"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal className="max-w-2xl mb-14">
        <Overline>Recent work</Overline>
        <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          Neat work, finished properly
        </h2>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-slate-600">
          A snapshot of the kind of jobs we do week in, week out.
        </p>
      </Reveal>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {gallery.map((g, i) => (
          <Reveal key={g.title} delay={i * 0.07}>
            <figure
              data-testid={`gallery-item-${i + 1}`}
              className={`group relative overflow-hidden rounded-md aspect-[4/5] bg-slate-100 ${
                i % 2 === 0 ? "rounded-tl-[2.5rem]" : "rounded-br-[2.5rem]"
              }`}
            >
              <img
                src={g.src}
                alt={g.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-slate-950/80 backdrop-blur-sm px-4 py-3.5">
                <p className="text-sm font-bold text-white leading-tight">{g.title}</p>
                <p className="text-xs font-semibold text-amber-400 mt-0.5">{g.area}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
